import { refreshAccessToken } from '@/shared/auth/auth.reducer';
import { getAccessToken } from '@/shared/auth/jwt-storage';
import { store } from '@/store/store';
import { createCrmSockJsWebSocket, readStompConnectHeaders } from './crmStompTransport';
export function createCrmStompLifecycleRefs() {
    return {
        stopped: { current: false },
        failureCount: { current: 0 },
        authRefreshInFlight: { current: false },
    };
}
/** Fresh JWT on every SockJS handshake (query param + STOMP CONNECT headers). */
export function createCrmStompWebSocketFactory(sockJsBaseUrl, onBeforeConnect) {
    return () => {
        onBeforeConnect?.();
        return createCrmSockJsWebSocket(sockJsBaseUrl);
    };
}
export async function refreshIamTokenForStomp() {
    try {
        await store.dispatch(refreshAccessToken()).unwrap();
        return Boolean(getAccessToken());
    }
    catch {
        return false;
    }
}
export function reconnectCrmStompClient(client, refs) {
    refs.stopped.current = false;
    refs.failureCount.current = 0;
    client.reconnectDelay = 5000;
    client.connectHeaders = readStompConnectHeaders();
    void client.deactivate().then(() => client.activate()).catch(() => undefined);
}
export function attachCrmStompTokenLifecycle(client, refs) {
    const onTokenUpdated = () => {
        reconnectCrmStompClient(client, refs);
    };
    window.addEventListener('callcenter-iam-tokens-updated', onTokenUpdated);
    return () => window.removeEventListener('callcenter-iam-tokens-updated', onTokenUpdated);
}
/**
 * On STOMP/SockJS auth failure: rotate access token once, then reconnect with the new JWT.
 * SockJS `/info` cannot reuse a URL that still carries an expired `access_token` query param.
 */
export async function handleCrmStompAuthFailure(client, refs, onStillFailed) {
    if (refs.authRefreshInFlight.current)
        return;
    refs.authRefreshInFlight.current = true;
    try {
        const ok = await refreshIamTokenForStomp();
        if (ok) {
            reconnectCrmStompClient(client, refs);
            return;
        }
        onStillFailed('STOMP auth rejected — chat disconnected (token refresh failed).');
    }
    finally {
        refs.authRefreshInFlight.current = false;
    }
}
